<template>
  <div id="nav">
    <router-view/>
  </div>
</template>
<style>
</style>
